export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20flat%20lay%20with%20various%20lifestyle%20products%20spread%20aesthetically%20on%20light%20cream%20surface%2C%20natural%20soft%20daylight%2C%20editorial%20European%20photography%2C%20gentle%20pastel%20palette%2C%20organized%20product%20arrangement%2C%20clean%20airy%20atmosphere%2C%20fashion%20and%20accessories%20flatlay&width=1600&height=700&seq=cta-bg-section&orientation=landscape"
          alt="Kakobuy Finds – Znaleziska zakupowe"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45"></div>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col items-start gap-8">
          <div className="max-w-md">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
              twoje znaleziska zakupowe
            </h2>
          </div>

          <div className="flex flex-col sm:flex-row items-start gap-6 sm:items-center w-full justify-between">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-3.5 bg-background-50 text-foreground-900 text-sm font-semibold rounded-full hover:bg-background-50/90 transition-all duration-200 whitespace-nowrap cursor-pointer group"
            >
              kakobuy sheet
              <span className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                <i className="ri-arrow-right-line text-background-50 w-4 h-4 flex items-center justify-center"></i>
              </span>
            </a>

            <p className="text-background-50/80 text-base md:text-lg max-w-sm leading-relaxed">
              Najlepsze produkty z Chin
              <br />
              Przeglądane i zweryfikowane
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}